/**
 * Shared domain vocabulary for the Study Document Workspace, backed by the `study-documents`
 * dataset. Design reasoning and the departures from the PRD live in docs/PRD_MOCKUPS_DESIGN_NOTES.md.
 */

import { ROLE_OPTIONS, type AssumedRole } from "@/contexts/AssumedRoleContext";

/** P0-1 controlled classification list. */
export type DocumentClass =
  | "protocol-class"
  | "plan"
  | "correspondence"
  | "reference"
  | "other";

/**
 * P0-5 — which Vivo roles may access a document, enforced at the retrieval layer rather
 * than in the UI.
 *
 * Expressed as real roles rather than an open/blinded flag: blinding is one reason to
 * restrict a document, not the only one, and Vivo already scopes what people see by
 * assumed role. An empty-of-restriction document lists every role.
 */
export type RoleAccess = AssumedRole[];

export const ALL_ROLES: AssumedRole[] = ROLE_OPTIONS.map(
  (option) => option.key,
);

/**
 * Upload is synchronous, so a document exists and is viewable as soon as it lands.
 * Scanning runs asynchronously afterwards and a failure is handled on the backend, so it is
 * neither a document state nor an event this workspace surfaces.
 */
export type DocumentState = "current" | "superseded" | "retired";

/** Whether a version's effective date is study-wide or negotiated per site. */
export type RolloutScope = "study" | "site";
